import { Routes } from '@angular/router';
import { MarketingWebsitePageId } from '@core/seo/marketing-website-seo.models';

function marketingContentRoute(path: string, pageId: MarketingWebsitePageId, i18nPrefix: string) {
  return {
    path,
    loadComponent: () =>
      import('./presentation/pages/website-content-page/website-content-page.component').then(
        (m) => m.WebsiteContentPageComponent
      ),
    data: { pageId, i18nPrefix },
  };
}

export const WebsiteRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./presentation/pages/website-home-page/website-home-page.component').then(
        (m) => m.WebsiteHomePageComponent
      ),
    data: { title: 'Milinco' },
  },
  {
    path: 'plan',
    loadComponent: () =>
      import('./presentation/pages/website-plan-select-page/website-plan-select-page.component').then(
        (m) => m.WebsitePlanSelectPageComponent
      ),
    data: { title: 'Elegir plan' },
  },
  {
    path: 'precios',
    loadComponent: () =>
      import('./presentation/pages/website-pricing-page/website-pricing-page.component').then(
        (m) => m.WebsitePricingPageComponent
      ),
    data: { title: 'Precios' },
  },
  marketingContentRoute('que-es-milinco', 'about', 'website.about'),
  marketingContentRoute('para/solo-link', 'vertical-solo-link', 'website.verticals.soloLink'),
  marketingContentRoute('para/tiendas', 'vertical-tiendas', 'website.verticals.tiendas'),
  marketingContentRoute('para/servicios', 'vertical-servicios', 'website.verticals.servicios'),
  marketingContentRoute('para/restaurantes', 'vertical-restaurantes', 'website.verticals.restaurantes'),
  marketingContentRoute('para/pos', 'vertical-pos', 'website.verticals.pos'),
  marketingContentRoute('para/farmacias', 'vertical-farmacias', 'website.verticals.farmacias'),
  marketingContentRoute('para/ferreterias', 'vertical-ferreterias', 'website.verticals.ferreterias'),
  marketingContentRoute('para/barberias', 'vertical-barberias', 'website.verticals.barberias'),
  marketingContentRoute('para/produccion', 'vertical-produccion', 'website.verticals.produccion'),
];
